export default __webpack_public_path__ + "static/cp-yellow-5a514c3cabddb74a94320f4e3488ff0e.png";